export const salesTable = {
    namespaced: true,
    state: {
        salesTable: null,
        salesTableConfig: null,
        salesTableCloneOptions: [],
        salesTableParcelTypes: [],
        salesTableDefaultConfigs: []
    },
    getters: {
        getSalesTableConfig: state => state.salesTableConfig,
        getSalesTableDelimiters(state) {
            let delimiters = state.salesTableConfig ? [...state.salesTableConfig.sales_table_flow] : []
            if (delimiters?.length) {
                delimiters = delimiters.filter(flow => {
                    return flow.sales_table_item.find(item => item.parcel_type === 'monthly')
                })
            }

            return delimiters
        },
        getSalesTableCloneOptions: state => state.salesTableCloneOptions,
        getSalesTableDefaultConfigs: state => state.salesTableDefaultConfigs,
        getSalesTableParcelTypes: state => state.salesTableParcelTypes,
        getSalesTable: state => state.salesTable
    },
    mutations: {
        SET_SALES_TABLE_CONFIG(state, payload){
            state.salesTableConfig = payload
        },
        SET_SALES_TABLE_CLONE_OPTIONS(state, payload){
            state.salesTableCloneOptions = payload
        },
      SET_SERIES_DEFAULT_CONFIGS(state, payload) {
        const parsedPayload = JSON.parse(payload || 'null');
        
        if (parsedPayload) {
            state.salesTableDefaultConfigs = parsedPayload;
        }
    },

        SET_SALES_TABLE_PARCEL_TYPES(state, payload){
            state.salesTableParcelTypes = payload
        },
        SET_SALES_TABLE(state, payload){
            state.salesTable = payload
        },
        SET_SALES_TABLE_PERMISSION(state, payload){
            state.salesTable.permissions = payload
        },
        SET_SALES_TABLE_INSTALLMENT_DATES(state, payload){
            state.salesTable.installments_date = payload
        }
    },
    actions: {
        setSalesTableConfig({ commit }, payload) {
            commit('SET_SALES_TABLE_CONFIG', payload)
        },

        setSalesTableCloneOptions({ commit }, payload) {
            commit('SET_SALES_TABLE_CLONE_OPTIONS', payload)
        },

        setSeriesDefaultConfigs({commit}, payload){
            commit('SET_SERIES_DEFAULT_CONFIGS', payload)
        },
        setSalesTableParcelTypes({commit}, payload){
            commit('SET_SALES_TABLE_PARCEL_TYPES', payload)
        },

        setSalesTable({ commit}, payload) {
            commit('SET_SALES_TABLE', payload)
        },

        updateSalesTablePermissions({commit}, payload){
            commit('SET_SALES_TABLE_PERMISSION', payload)
        },

        updateSalesTableInstallmentDates({commit}, payload){
            commit('SET_SALES_TABLE_INSTALLMENT_DATES', payload)
        }
    }
}